import { Check } from "lucide-react";

export default function TaskPicker({ list = [], value = [], onChange, testid = "task-picker" }) {
  const toggle = (t) => onChange(value.includes(t) ? value.filter((x) => x !== t) : [...value, t]);
  return (
    <div data-testid={testid}>
      <div className="flex flex-wrap gap-1.5">
        {list.map((t) => {
          const on = value.includes(t);
          return (
            <button type="button" key={t} onClick={() => toggle(t)} data-testid={`${testid}-${t.replace(/\s+/g, "-").toLowerCase()}`}
              className={`inline-flex items-center gap-1 px-2.5 py-1.5 rounded-md border text-xs font-semibold transition-colors ${on ? "bg-primary text-primary-foreground border-primary" : "border-border text-muted-foreground hover:bg-accent"}`}>
              {on && <Check className="w-3 h-3" />}{t}
            </button>
          );
        })}
      </div>
      <div className="flex gap-3 mt-1.5 text-[11px]">
        <button type="button" onClick={() => onChange([...list])} className="text-primary hover:underline" data-testid={`${testid}-all`}>Select all</button>
        <button type="button" onClick={() => onChange([])} className="text-muted-foreground hover:underline" data-testid={`${testid}-none`}>Clear</button>
        <span className={value.length ? "text-muted-foreground" : "text-red-400"}>{value.length ? `${value.length} selected` : "Pick at least one task"}</span>
      </div>
    </div>
  );
}
